import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  filterHandler,
  notifyUser,
  showFlowType,
} from "../../services/helpers";

import { Table, Icon, Alert, Chip } from "design-react-kit";

import "../../assets/Table.css";
import secureLocalStorage from "react-secure-storage";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import CopyClientConfigurationModal from "../Modals/CopyClientConfigurationModal";
import UserContext from "../../store/user-context";

const ClientConfigurationTable = ({
  items,
  columns,
  openModalHandler,
  confirmModalOpenHandler,
  getClientConfigurations,
}) => {
  const [results, setResults] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [destinationClientId, setDestinationClientId] = useState(null);
  const [sourceMunicipalityName, setSourceMunicipalityName] = useState(null);
  const [sourceClientName, setSourceClientName] = useState(null);

  const userContext = useContext(UserContext);

  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
    setSourceClientName(secureLocalStorage.getItem("sourceClientName"));
    setSourceMunicipalityName(
      secureLocalStorage.getItem("sourceMunicipalityName")
    );
  }, [items]);

  const showClientStatus = (status, label) => {
    if (status === 5) {
      return (
        <Chip color="success" className="text-nowrap">
          {label}
        </Chip>
      );
    } else {
      return (
        <Chip color="danger" className="text-nowrap">
          {label}
        </Chip>
      );
    }
  };

  const copyToClipboardHandler = (result) => {
    secureLocalStorage.setItem("sourceClientId", result.clientId);
    secureLocalStorage.setItem("sourceClientName", result.clientCodeName);
    secureLocalStorage.setItem(
      "sourceMunicipalityName",
      userContext.selectedClientName
    );
    notifyUser(
      "Configurazione memorizzata correttamente",
      "success",
      "it-check"
    );
    setSourceClientName(result.clientCodeName);
    setSourceMunicipalityName(userContext.selectedClientName);
  };

  const modalOpenHandler = (clientId) => {
    setDestinationClientId(clientId);
    setModalOpen(true);
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Ricerca per tipologia servizio"}
            column={"clientCodeName"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getClientConfigurations()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.clientCode}>
                    <td className="clientName text-center">
                      {result.clientCodeName}
                    </td>
                    <td className="clientCode text-center">
                      {result.clientCode}
                    </td>
                    <td className="format text-center">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="awsBucketName text-nowrap text-center">
                      {showClientStatus(
                        result.clientConfigurationStatusId,
                        result.clientConfigurationStatusLabel
                      )}
                    </td>
                    <td className="awsBucketName text-nowrap text-center">
                      {result.s3BucketName}
                    </td>
                    <td className="actions text-center">
                      <span
                        title="Configura tipologia servizio"
                        className="mr-2"
                      >
                        <Icon
                          id="edit-client"
                          icon="it-pencil"
                          fill="#06c"
                          role="button"
                          onClick={(e) => openModalHandler(result)}
                        />
                      </span>
                      {(result.clientConfigurationStatusId === 1 ||
                        result.clientConfigurationStatusId === 5) && (
                        <span
                          title="Esporta configurazione in memoria"
                          className="mr-2"
                        >
                          <Icon
                            id="copy-client-configuration"
                            icon="it-copy"
                            fill="#06c"
                            role="button"
                            onClick={(e) => {
                              copyToClipboardHandler(result);
                            }}
                          />
                        </span>
                      )}
                      {result.clientConfigurationStatusId === 3 &&
                        sourceMunicipalityName !== null &&
                        sourceMunicipalityName !== "" &&
                        sourceClientName !== null &&
                        sourceClientName !== "" && (
                          <span
                            title="Importa configurazione memorizzata"
                            className="mr-2"
                          >
                            <Icon
                              id="import-client-configuration"
                              icon="it-plus"
                              fill="#06c"
                              role="button"
                              onClick={(e) => {
                                modalOpenHandler(result.clientId);
                              }}
                            />
                          </span>
                        )}
                      {result.s3BucketName !== null &&
                        result.s3BucketName !== undefined &&
                        result.s3BucketName !== "" && (
                          <span
                            title="Configura tipologia documenti"
                            className="mr-2"
                          >
                            <Icon
                              id="configure-documents"
                              icon="it-piattaforme"
                              fill="#06c"
                              role="button"
                              onClick={(e) =>
                                navigate(
                                  `/clientConfiguration/clientDocumentsConfiguration/${result.clientCodeName}/${result.clientId}`
                                )
                              }
                            />
                          </span>
                        )}
                      <img
                        title="Verifica"
                        alt="Verifica"
                        className="preview-icon mr-2 ml-2"
                        src="./document-check-blue.png"
                        role="button"
                        onClick={(e) => {
                          secureLocalStorage.setItem("edit", null);
                          navigate(
                            `/clientConfiguration/check/${result.clientId}/${result.clientCodeName}`
                          );
                        }}
                      />
                      <span title="Rimuovi configurazione">
                        <Icon
                          id="delete-configuration"
                          icon="it-delete"
                          fill="#005A9A"
                          role="button"
                          onClick={(e) => confirmModalOpenHandler(result)}
                        />
                      </span>
                    </td>
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <CopyClientConfigurationModal
          modalOpen={modalOpen}
          modalCloseHandler={modalCloseHandler}
          destinationClientId={destinationClientId}
          getClientConfigurations={getClientConfigurations}
        />
      </div>
    </Fragment>
  );
};

export default ClientConfigurationTable;
